import React, {useEffect, useRef, useState} from 'react';
import '../css/AppHeader.css';
import { apiFetchJson } from 'apiClient';
import "./css/NotificationCenter.css";
import { useStackedPopup } from "@dashboard/contexts/PopupStackContext"; // 🔹 NEW
import { useNavigate } from "react-router-dom";

const FRONTEND_BASE =
    process.env.REACT_APP_API_BASE ||
    window.location.origin; // fall back to current origin

const NotificationCenter = ({ onPendingContractNotesClick }) => {
    const [pendingCnoteCount, setPendingCnoteCount] = useState(0);
    const [notifications, setNotifications] = useState([]);
    const [notifMenuOpen, setNotifMenuOpen] = useState(false);

    const hasPendingCnotes = pendingCnoteCount > 0;
    // We keep pendingCnotes as "one" notification, plus each other notification
    const notifMenuOpenRef = useRef(null);
    const [aoNotifications, setAoNotifications] = useState([]);
    const totalNotifications =
        (hasPendingCnotes ? 1 : 0) + notifications.length + aoNotifications.length;
    const hasNotifications = totalNotifications > 0;
    const navigate = useNavigate();

    const extractOrderIdFromMessage = (msg) => {
        if (!msg) return null;

        const m = String(msg).match(/\[Order\s+(\d+)\]/i);
        if (!m) return null;

        const id = Number(m[1]);
        return Number.isFinite(id) ? id : null;
    };

    const handleAoNotifClick = (e, n) => {
        e?.stopPropagation?.();
        const id =
            n?.advancedOrderId ||
            n?.target?.highlightId ||
            extractOrderIdFromMessage(n?.message);

        console.log("AO notif clicked id=", id, "payload=", n);

        if (!id) return;
        setNotifMenuOpen(false);
        navigate({
                 pathname: window.location.pathname,
                 search: `?vc=AO&highlightOrderId=${id}`,
               });
    };


    useEffect(() => {
        if (!notifMenuOpen) return;

        const handleClickOutside = (event) => {
            if (notifMenuOpenRef.current && !notifMenuOpenRef.current.contains(event.target)) {
                setNotifMenuOpen(false);
            }
        };

        /*document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);*/
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, [notifMenuOpen]);

    useEffect(() => {
        let mounted = true;

        const loadPendingCounts = async () => {
            try {
                const data = await apiFetchJson('/api/portfolio/pending/count');
                if (mounted) {
                    setPendingCnoteCount(data?.count || 0);
                }
            } catch (e) {
                console.error('Failed to load pending contract note count', e);
            }
        };

        const loadNotifications = async () => {
            try {
                const data = await apiFetchJson('/api/notifications/active');
                if (mounted) {
                    setNotifications(Array.isArray(data) ? data : []);
                }
            } catch (e) {
                console.error('Failed to load notifications', e);
            }
        };

        loadPendingCounts();
        loadNotifications();

        //console.log(`⏳ Connecting to SSE ${FRONTEND_BASE}/events/cnote…`);

        const eventSource = new EventSource(`${FRONTEND_BASE}/events/stream`, {
            withCredentials: false
        });

        eventSource.addEventListener('connected', (e) => {
            console.log('🔗 SSE Connected:', e.data);
        });

        eventSource.addEventListener('cnote', () => {
            console.log('📩 SSE event: new contract note detected');
            loadPendingCounts();
        });

        eventSource.addEventListener('notification', () => {
            console.log('🔔 SSE event: new generic notification');
            loadNotifications();
        });

        eventSource.addEventListener('notificationsChanged', () => {
            console.log('🔁 SSE event: notification list changed');
            loadNotifications();
        });

        eventSource.onerror = (err) => {
            console.warn('⚠️ SSE error:', err);
        };

        const aoEventSource = new EventSource(`${FRONTEND_BASE}/events/stream`, {
            withCredentials: false
        });

        aoEventSource.addEventListener("connected", (e) => {
            console.log("🔗 AO SSE Connected:", e.data);
        });

        const addAoNotificationFromEvent = (event) => {
            try {
                const payload = JSON.parse(event.data);

                setAoNotifications((prev) => {
                    const next = [payload, ...prev];
                    return next.slice(0, 25);
                });
            } catch (e) {
                console.error("Failed to parse AO SSE event", e, event?.data);
            }
        };

        aoEventSource.addEventListener("aoInfo", addAoNotificationFromEvent);
        aoEventSource.addEventListener("aoWarning", addAoNotificationFromEvent);
        aoEventSource.addEventListener("aoError", addAoNotificationFromEvent);

// backward compatibility (safe to keep)
        aoEventSource.addEventListener("fundsWarning", addAoNotificationFromEvent);

        aoEventSource.onerror = (err) => {
            console.warn("⚠️ SSE error (advanced-orders):", err);
        };

        return () => {
            mounted = false;
            eventSource.close();
            aoEventSource.close();
            console.log('🔌 SSE closed');
        };
    }, []);

     const toggleNotifMenu = (e) => {
             e.stopPropagation();
             setNotifMenuOpen((open) => !open);
     };

    const handleCloseMenu = () => {
        setNotifMenuOpen(false);
    };

    const handlePendingCnoteClick = () => {
        setNotifMenuOpen(false);
        if (onPendingContractNotesClick) {
            onPendingContractNotesClick();
        }
    };

    const handleClearNotification = async (id) => {
        try {
            const data = await apiFetchJson(`/api/notifications/${id}/clear`, {
                method: 'POST'
            });
            setNotifications(Array.isArray(data) ? data : []);
        } catch (e) {
            console.error('Failed to clear notification', e);
        }
    };

    const handleClearAllNotifications = async () => {
        try {
            const data = await apiFetchJson('/api/notifications/clear-all', {
                method: 'POST'
            });
            setNotifications(Array.isArray(data) ? data : []);
            setAoNotifications([]);

        } catch (e) {
            console.error('Failed to clear all notifications', e);
        }
    };

    const formatDateTime = (iso) => {
        if (!iso) return '';
        try {
            return new Date(iso).toLocaleString();
        } catch {
            return '';
        }
    };
    const getAoNotifClass = (n) => {
        const sev = String(n?.severity || "").toUpperCase();
        if (sev === "ERROR") return "notif-menu-item-danger";
        if (sev === "INFO") return "notif-menu-item-info";
        return "notif-menu-item-warning"; // default WARN
    };

    // 🔹 Register this dropdown on the global popup stack so ESC closes it
    useStackedPopup(notifMenuOpen, () => {
        // Only need to close the menu; no external onClose prop required
        setNotifMenuOpen(false);
    });

    return (
        <div className="app-header-notification-wrapper">
            <button
                type="button"
                className={
                    'app-header-notification-btn' +
                    (hasNotifications && !notifMenuOpen ? ' has-notifications' : '')
                }
                onClick={toggleNotifMenu}
                title={
                    hasNotifications
                        ? `${totalNotifications} notification(s)`
                        : 'No notifications'
                }
            >
                <span className="notif-icon">🔔</span>
                {hasNotifications && (
                    <span className="notif-count-badge">
                        {totalNotifications}
                    </span>
                )}
            </button>

            {notifMenuOpen && (
                <div
                    ref={notifMenuOpenRef}
                    className="app-header-notification-menu"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="notif-menu-header">
                        <span className="notif-menu-title">Notifications</span>

                        <div className="notif-menu-header-right">
                            {notifications.length > 0 && (
                                <button
                                    type="button"
                                    className="notif-clear-all-btn"
                                    onClick={handleClearAllNotifications}
                                >
                                    Clear all
                                </button>
                            )}
                            <button
                                type="button"
                                className="notif-close-btn"
                                onClick={handleCloseMenu}
                                title="Close notifications"
                            >
                                ✕
                            </button>
                        </div>
                    </div>

                    <div className="notif-menu-item-container">
                    {hasPendingCnotes && (
                        <div
                            className="notif-menu-item notif-menu-item-warning"
                            onClick={handlePendingCnoteClick}
                        >
                            <div className="notif-item-title">
                                Pending contract notes to import
                            </div>
                            <div className="notif-item-subtitle">
                                You have {pendingCnoteCount} contract note
                                {pendingCnoteCount > 1 ? 's' : ''} not yet imported.
                            </div>
                        </div>
                    )}
                    {aoNotifications.map((n, idx) => (
                        <div
                            key={`ao-${idx}`}
                            className={`notif-menu-item ${getAoNotifClass(n)} notif-clickable`}
                            onClick={(e) => { handleAoNotifClick(e, n); }}

                            title={n?.advancedOrderId ? `Open order #${n.advancedOrderId}` : ""}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") handleAoNotifClick(e, n);
                            }}
                        >
                            <div className="notif-item-row">
                                <div className="notif-item-main">
                                    <div className="notif-item-title">
                                        {n.title || n.type || "Advanced Order"}
                                    </div>

                                    <div className="notif-item-subtitle" style={{ whiteSpace: "pre-line" }}>
                                        {n.message}
                                    </div>

                                    {n.createdAt && (
                                        <div className="notif-item-meta">
                                            {formatDateTime(n.createdAt)}
                                        </div>
                                    )}
                                </div>

                                <button
                                    type="button"
                                    className="notif-clear-btn"
                                    onClick={(e) => {
                                        e.stopPropagation(); // ✅ don’t trigger open-on-click
                                        setAoNotifications((prev) => prev.filter((_, i) => i !== idx));
                                    }}
                                >
                                    Clear
                                </button>
                            </div>
                        </div>
                    ))}


                    {notifications.map((n) => (
                        <div
                            key={n.id}
                            className="notif-menu-item notif-clickable"
                            role="button"
                            tabIndex={0}
                            title="Open related order"
                            onClick={(e) => handleAoNotifClick(e, n)}   // uses extractOrderIdFromMessage(n.message)
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") handleAoNotifClick(e, n);
                            }}
                        >
                            <div className="notif-item-row">
                                <div className="notif-item-main">
                                    <div className="notif-item-title">
                                        {n.type || 'Notification'}
                                    </div>
                                    <div className="notif-item-subtitle">
                                        {n.message}
                                    </div>
                                    {n.createdAt && (
                                        <div className="notif-item-meta">
                                            {formatDateTime(n.createdAt)}
                                        </div>
                                    )}
                                </div>
                                <button
                                    type="button"
                                    className="notif-clear-btn"
                                    onClick={(e) => {
                                        e.stopPropagation();                 // don't navigate
                                        handleClearNotification(n.id);
                                    }}
                                >
                                    Clear
                                </button>
                            </div>
                        </div>
                    ))}

                    {!hasPendingCnotes && notifications.length === 0 && aoNotifications.length === 0 && (
                        <div className="notif-menu-empty">
                            No pending notifications.
                        </div>
                    )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default NotificationCenter;
